import availableImages from '../constants/availableImages';

import utils from './index';

const isImage = fileName => availableImages.includes(utils.getFileExtension(fileName).toLocaleLowerCase());

export default isImage;
